// Packages
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  grid: {
    marginTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  content: {
    marginTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    height: "auto",
    width: "50%",
    fontWeight: "bold",
    textAlign: "center",
  },
  invalidContent:{
    marginTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    height: "auto",
    width: "90%",
    fontWeight: "bold",
    textAlign: "left",
  },
}));
